<template>
  <el-menu
    :class="{'first-nav-bar': currentAuth.length === 0}"
    mode="horizontal"
    background-color="#304156"
    text-color="#FFFFFF"
    active-text-color="#409EFF"
    :default-active="currentPage"
    @select="handleMenuSelect"
  >
    <el-menu-item v-for="item in currentAuth" :key="item.index" :index="item.index">{{ item.rightName }}</el-menu-item>
  </el-menu>
</template>
<script>
import { mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      currentAuth: []
    }
  },
  computed: {
    ...mapState('userinfo', ['currentPage', 'userInfo', 'auth'])
  },
  created() {
    if(this.auth.length > 0) {
      this.auth.forEach(menu => {
        if (menu.path === '/nurseManage') {
          this.currentAuth.push({
            index: '1',
            rightName: '医护管理'
          })
        } else if (menu.path === '/userManage') {
          this.currentAuth.push({
            index: '2',
            rightName: '用户管理'
          })
        } else if (menu.path === '/systemManage') {
          this.currentAuth.push({
            index: '3',
            rightName: '系统设置'
          })
        } else if (menu.path === '/diabetesManage') {
          this.currentAuth.push({
            index: '4',
            rightName: '数据记录'
          })
        } else if (menu.path === '/pointsManage') {
          this.currentAuth.push({
            index: '5',
            rightName: '积分体系'
          })
        } else if (menu.path === '/shoppMall') {
          this.currentAuth.push({
            index: '6',
            rightName: '商城'
          })
        } else if (menu.path === '/reportForm'){
          this.currentAuth.push({
            index: '7',
            rightName: '数据报表'
          })
        } else if (menu.path === '/questionnaireActivity'){
          this.currentAuth.push({
            index: '8',
            rightName: '问卷活动'
          })
        }
      })
      if (!this.currentPage) {
        this.changeCurrentPage(this.currentAuth[0].index)
      }   
    } 
  },
  methods: {
    ...mapMutations('userinfo', ['changeCurrentPage']),
    handleMenuSelect(index) {
      this.changeCurrentPage(String(index))
      this.$router.push({ path: '/dashboard' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .first-nav-bar {
    height: 60px;
    border-bottom: 1px solid #e6e6e6;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/FirstNavbar.vue